import EntityFormField from 'vue-forms/components/EntityFormField';

export default {
  mixins: [ EntityFormField ],

  props: {
    component: {
      default: 'tag-input-field'
    },

    context: {
      type: String,
      default: 'default'
    },

    contextId: {
      default: undefined
    }
  }
};
